import React from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { NavLink } from 'react-router-dom';
import { createContact } from '../api/auth/ContactusService';
import ReCAPTCHA from 'react-google-recaptcha';
import { useState } from 'react';

//import { PreLoginUUID,PostLoginUUID,getToken,saveToken } from '../utils/auth';
function Contactus() {
  const [values, setValues] = React.useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    address: "",
    message: "",
    date: ""

  });

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const currentDate = new Date().toISOString().split("T")[0];

    const payload = {
      ...values,
      date: currentDate
    };
    try {
      const response = await createContact(payload);

      console.log(response.data);
      alert("Message sent successfully!");
      setValues({
        name: "",
        email: "",
        phone: "",
        subject: "",
        address: "",
        message: "",
        date: ""

      });
    } catch (error) {
      console.error("There was an error sending the message!", error);
      alert("Message not sent");
    }
  };
  const RECAPTCHA_SITE_KEY = '6LelQl8sAAAAAAwguGauQBv1OzVU1wYWbqDE6sIF'; // Replace with your key

  // Add a new state for the captcha value
  const [setCaptchaValue] = useState(null);

  // Captcha change handler
  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };



  return (
    <div>
      <Header />
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>Contact Us</h2>
                <ul className="bread-list">
                  <li><NavLink to='/'>Home</NavLink></li>
                  <li><i className="icofont-simple-right" /></li>
                  <li className="active">Contact Us</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="contact-us section">
        <div className="container">
          <div className="inner">
            <div className="row">
              <div className="col-lg-6 col-12">
                <div className="mapouter">
                  <iframe
                    title="Webnet Technologies Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224.8624238309986!2d85.05751936742585!3d25.611601800000013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x140d7ef1cbc89299%3A0x5de746c560fb99d6!2sWebnet%20Technologies!5e0!3m2!1sen!2sin!4v1746784878553!5m2!1sen!2sin"
                    width="100%"
                    height="750px"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>

              {/* Contact Form */}
              <div className="col-lg-6 col-12 d-flex">
                <div className="contact-us-form">
                  <h2>Contact With Us</h2>
                  <p>If you have any questions please feel free to contact with us.</p>
                  <form className="form" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="name"
                            placeholder="Name"
                            onChange={handleChanges}
                            value={values.name}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            onChange={handleChanges}
                            value={values.email}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="phone"
                            placeholder="Phone"
                            onChange={handleChanges}
                            value={values.phone}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="subject"
                            placeholder="Subject"
                            onChange={handleChanges}
                            value={values.subject}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="address"
                            placeholder="Address"
                            onChange={handleChanges}
                            value={values.address}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <textarea
                            name="message"
                            placeholder="Your Message"
                            onChange={handleChanges}
                            value={values.message}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <ReCAPTCHA
                            sitekey={RECAPTCHA_SITE_KEY}
                            onChange={handleCaptchaChange}
                          />
                        </div>
                      </div>


                      <div className="col-12">
                        <div className="form-group login-btn">
                          <button className="btn" type="submit">Send</button>
                        </div>
                        {/* <div className="checkbox">
                          <label className="checkbox-inline" htmlFor="newsletter">
                            <input type="checkbox" id="newsletter" name="news" />
                            Do you want to subscribe to our Newsletter?
                          </label>
                        </div> */}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <div className="row">
              <div className="col-lg-4 col-12">
                <div className="single-info">
                  <i className="icofont icofont-ui-call" />
                  <div className="content">
                    <h3>+91 805 131 6666</h3>
                    <p className='mt-4'>
                      <i className="fa fa-envelope" style={{ fontSize: '34px' }}></i>
                      support@webnettechnologies.org
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <div className="single-info">
                  <i className="icofont-google-map" />
                  <div className="content">
                    <h3>Webnet Technologies</h3>
                    <p>Bailey Road, Gola Road, More, near Petrol Pump, Patna, Bihar 801503</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <div className="single-info">
                  <i className="icofont icofont-wall-clock" />
                  <div className="content">
                    <h3>Time: 10am - 6pm</h3>
                    {/* <p>Sunday Closed</p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Contactus;
